import type { PropsWithChildren } from 'react';
import * as React from 'react';

import { makeStyles } from 'tss-react/mui';
import { type ITheme } from '../../theme';

const useStyles = makeStyles()((theme: ITheme) => ({
  primaryGradient: {
    backgroundImage: theme?.gradients?.primaryGradient,
    color: '#fff',
  },
  secondaryGradient: {
    backgroundImage: theme?.gradients?.secondaryGradient,
    color: '#47495a',
  },
  blackFriday: {
    color: '#fff',
  },
}));

export interface ThemedRowProps extends PropsWithChildren {
  backgroundGradient?: 'primary' | 'secondary' | 'blackFriday';
  backgroundImgUrl?: string;
}

const ThemedRow: React.FC<ThemedRowProps> = ({
  backgroundGradient = 'primary',
  backgroundImgUrl,
  children,
}) => {
  const { classes } = useStyles();
  let backgroundCls;

  if (backgroundGradient === 'secondary') {
    backgroundCls = classes.secondaryGradient;
  } else if (backgroundGradient === 'blackFriday') {
    if (!backgroundImgUrl) throw new Error('Image ressource not set.');
    backgroundCls = classes.blackFriday;
    return (
      <div
        className={backgroundCls}
        style={{
          backgroundImage: `url('${backgroundImgUrl}')`,
          backgroundColor: '#000',
          backgroundPosition: 'center bottom',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }}
      >
        {children}
      </div>
    );
  } else {
    backgroundCls = classes.primaryGradient;
  }

  return <div className={backgroundCls}>{children}</div>;
};

export default ThemedRow;
